export const initglobalStore = JSON.parse(window.localStorage.getItem('calyx-tools') || '{}')

/**
 * @typedef {Object} CustomAction
 * @property {'LOGIN' | 'LOGOUT' | string} CustomAction.type
 * 
 * @param {*} state 
 * @param {CustomAction} action 
 * @returns 
 */
const reducer = (state, action) => {
  const { type, payload, callback } = action
  console.log(`reducer got action = ${JSON.stringify(action)}`)
  switch (type) {
    case 'LOGIN': {
      const newState = { ...state, isLogin: true, token: payload.jwt, user: payload.user }
      window.localStorage.setItem('jwt', payload.jwt)
      window.localStorage.setItem('calyx-tools', JSON.stringify(newState))
      return { ...newState }
    }
    case 'LOGOUT': {
      window.localStorage.clear()
      window.location = '/'
      return {}
    }
    default:
      return state
  }
}

export default reducer
